<div class="progress-bar">
  <div
    class="progress-bar-section status-error"
    [style.width.%]="((progress?.error || 0) / totalLength) * 100"
  ></div>
  <div
    class="progress-bar-section status-success"
    [style.width.%]="((progress?.success || 0) / totalLength) * 100"
  ></div>
  <div
    class="progress-bar-section status-info"
    [style.width.%]="((progress?.info || 0) / totalLength) * 100"
  ></div>
</div>
